import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import * as React from 'react';
import styled from 'styled-components';

import { MonologScriptSnapshotIn } from '../../question-data-model/Script/_implementations/monolog-script.store';

export const Main = styled.div`
  .row-item {
    margin-bottom: 16px;
  }
  .txt-monolog-script {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: ${colorsV2.black100};
  }
`;

interface TranscriptMonologContentProps {
  script: MonologScriptSnapshotIn;
}

export const TranscriptMonologContent = (props: TranscriptMonologContentProps) => {
  const { script } = props;

  return (
    <Main>
      {script.subtitle.map((item, index) => {
        const { data } = item;
        return (
          <div className="row-item" key={index}>
            <div className="txt-monolog-script">{data.text}</div>
          </div>
        );
      })}
    </Main>
  );
};
